export var SelectorType;
(function (SelectorType) {
    SelectorType["INCLUDE"] = "INCLUDE";
    SelectorType["EXCLUDE"] = "EXCLUDE";
    SelectorType["RANGE"] = "RANGE";
})(SelectorType || (SelectorType = {}));
